import { queryClient } from '@configuration/queryClient.config';
import { listAnnouncementAPI } from '@/service';
import { useQuery } from '@tanstack/react-query';

const listAnnouncementsBaseQueryKey = ['listAnnouncements'];

export const listAnnouncementsQueryKey = (stopIds) => [
  ...listAnnouncementsBaseQueryKey,
  ...stopIds,
];

const getListAnnouncementsFetchFunction = (stopIds: number[]) => () =>
  listAnnouncementAPI({ stopIds });

export const useListAnnouncementsQuery = (stopIds: number[]) => {
  return useQuery({
    queryKey: listAnnouncementsQueryKey(stopIds),
    queryFn: getListAnnouncementsFetchFunction(stopIds),
    select: (response) => response?.data,
  });
};

export const invalidateListAnnouncementsQueryKey = () => {
  return queryClient.invalidateQueries({
    queryKey: listAnnouncementsBaseQueryKey,
  });
};
